import { render, staticRenderFns } from "./ValidateLanding.vue?vue&type=template&id=941ae4c6&"
import script from "./ValidateLanding.vue?vue&type=script&lang=js&"
export * from "./ValidateLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports